<!-- =========================================================================================
  File Name: DataListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar"  :data="sidebarData" />
    <data-view-camusersidebar :isCamUserSidebarActive="addNewCamUserSidebar" @getdata="getdata" @closeCamUserSidebar="toggleCamUserSidebar" :data="camUserSidebarData" />
    <student-setting-sidebar :isSettingSidebarActive="addSettingSidebar" @getdata="getdata" @closeSidebar="toggleSettingSidebar" :data="sidebarSettingData" />
    <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @getdata="getdata" @closeSidebar="toggleScheduleSidebar" :data="scheduleData" />

<!-- ADD NEW -->
 <vs-popup fullscreen title="" :active.sync="popupActive">
    <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset"  allowfullscreen></iframe>
  </div>
      </vs-popup>
    <div>
    <vs-button class="user_add_btn" type="filled" @click="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> {{ $t('student.add.title') }}</vs-button>
  <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
  </div>
   <vs-table ref="table"  :data="filteredStudentList" :max-items="itemsPerPage"  pagination
              search>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="select>0" vs-trigger-click class="dd-actions cursor-pointer ml-4 mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">{{ $t('common.action') }} ({{selected.length}})</span>
       </div>
            <vs-dropdown-menu>
              <vs-dropdown-item>
                <span class="flex items-center" @click="selectAction('deletestudent')">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>{{ $t('common.delete') }}</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="selectAction('activestudent')">
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.enable') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span class="flex items-center" @click="selectAction('deactivestudent')">
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.disable') }} </span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item  @click="genQr()" >
                <span class="flex items-center">
                  <feather-icon icon="CodepenIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <span>{{ $t('common.qr_code') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item  @click="SMSpopup()" >
                <span class="flex items-center">
                  <feather-icon icon="MessageSquareIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <span>Send SMS</span>
                </span>
              </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>
        <vx-tooltip text="Search By Location" position="top" v-if="locln>1">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">{{ $t('student.filters.search_by_location') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location');updateCamraList('all')">
                <span class="flex items-center">
                  <span>{{ $t('student.filters.all') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span @click="updateCamraList(location.id)">{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
           <vx-tooltip text="Search By Camera" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter_camera">{{ $t('student.filters.search_by_camera') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="cameraSelected('Search By Camera')">
                <span class="flex items-center">
                  <span  >{{ $t('student.filters.all') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="camera in cameras" :key="camera.id" @click="cameraSelected(camera.name)">
                <span class="flex items-center">
                  <span >{{ camera.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
           <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mb-5" >
                  <div >
                    <feather-icon svgClasses="w-8 h-8 hover:text-primary stroke-current"  icon="FilterIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu class="mb-5">
                  <vs-dropdown-item>
                  <span class="flex items-center"  @click="getArchive()">
                 <feather-icon icon="ArchiveIcon" svgClasses="h-6 w-6" class="mr-2 "/>  <span> Archived </span>
                </span>
                  </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
           <!-- <vs-button @click="ArchivePopup=true" class="dd-actions cursor-pointer ml-1 mb-4">Archive</vs-button> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ students.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : students.length }} of {{ queriedStudents }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>

      </div>

      <template slot="thead" >
        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th>
        <span  @click="sorting('name')">{{ $t('student.table.name') }}</span>
        <feather-icon v-if="order && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" />
        <feather-icon v-if="!order && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" />
        </vs-th>

        <!-- <vs-th>
        <span  @click="sorting('name')">{{ $t('student.table.name') }}</span>
        <feather-icon v-if="order && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" />
        <feather-icon v-if="!order && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" />
        </vs-th> -->
        <vs-th>{{ $t('student.table.users') }}</vs-th>
        <vs-th>{{ $t('student.table.program') }}</vs-th>
        <vs-th>
        <span  @click="sortingstatus('status')">{{ $t('student.table.status') }}</span>
        <feather-icon v-if="statusorder && state" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        <feather-icon v-if="!statusorder && state" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        </vs-th>
        <vs-th>{{ $t('student.table.cameras') }}</vs-th>
        <vs-th>{{ $t('student.table.action') }}</vs-th>
      </template>

        <template slot-scope="{data}" >
          <tbody >
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]"></vs-checkbox></vs-td>
            <vs-td  >
           <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/'+ tr.id}" class="text-inherit " >
           <img v-if="tr.image" :src="img_cdn+tr.image" class="rounded-full shadow-md studentdot mr-2"/>
           <p v-else class="bg-primary studentdot text-white mr-2" :data-letterstudent=tr.fname[0].toUpperCase()></p>
          <!-- <img  :src="`/storage/images/${tr.image}`" class="rounded-full shadow-md product-img" /> -->
              <!-- <img :src="tr.image"   class="rounded-full shadow-md product-img" /> -->
           </router-link>
                <span v-if="lng=='dogs'" class="text-sm font-bold">{{tr.fname}}</span>
                <span v-else class="text-sm font-bold">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</span>

            </vs-td>

                <vs-td>
                <div v-for="item in tr.users" :key="item.id">
                   <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/'+ item.id}" class="text-inherit underline">
                 <vs-chip >{{item.fname}} {{item.lname}}</vs-chip>
                  </router-link>
                </div>
                <!-- <feather-icon class="text-primary text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" icon="UserPlusIcon" svgClasses="h-4 w-4"/>  -->


              <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-button  class="text-center"   @click.stop="addNewCamUser(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>

              <!-- <vs-button size="small" class="text-center" style="width:10px;float:left"  @click.stop="addNewCamUser(tr)"> -->
                 <!-- <feather-icon class="text-primary text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" icon="UserPlusIcon" svgClasses="h-4 w-4"/>  -->
                 <!-- <vs-button  class="text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>  -->
                <!-- {{ $t('student.table.add_user') }} -->
                <!-- </vs-button> -->
                <!-- <vs-button radius color="danger" type="gradient" icon-pack="feather" icon="icon-user-plus"></vs-button> -->
              </vs-col>
               </vs-row>
              </vs-td>
              <!-- <vs-td>
                <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/'+ tr.id}" class="text-inherit " >
                <p v-if="lng=='dogs'" class="text-sm font-small">{{tr.fname}}</p>
                <p v-else class="text-sm font-small">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</p>
                </router-link>
              </vs-td> -->
              <vs-td>
                <vs-chip v-if="tr.program.color_code" class="product-order-status text-white" :style="{background: tr.program.color_code}">{{ tr.program.name | title }}</vs-chip>
                <vs-chip v-else class="product-order-status" >{{ tr.program.name | title }}</vs-chip>
              </vs-td>
              <vs-td>
                <vs-switch @input="confStatus(tr.status,tr.id)"  v-model="tr.status"></vs-switch>
              </vs-td>
              <vs-td>
              <vx-tooltip class="vs-display" v-for="item in tr.cameras" :key="item.id" :text="item.name" position="top">
               <span   @click="PalyCamera"  :style="{background: item.color_code}" class="w-4 h-4 round" style="float: left"></span>
                </vx-tooltip>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                  <span class="flex items-center">
                  <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/' + tr.id}" class="text-inherit " >
                 <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2 "/>  <span> View </span>
                  <!-- <span> {{ $t('common.edit') }} </span> -->

                </router-link>
                </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> {{ $t('common.edit') }} </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>{{ $t('common.delete') }}</span>
                </span>
                </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="settingData(tr)">
                  <feather-icon icon="SettingsIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.settting') }}</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item>
                <span class="flex items-center" @click="addSchedule(tr)">
                  <feather-icon icon="CalendarIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.schedule') }}</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
     <div class="demo-alignment">
      <div class="fill-row-loading">
        <div :class="{'activeLoading':activeLoading}"  :id="[`loading-sound`]" class="vs-con-loading__container loading-example">
        </div>
      </div>
  </div>
  <vs-popup class="holamundo" title="QR Code" :active.sync="QRpopupActive">
             <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <vue-qrcode :value="Qr_link" :width="400" ref="QR" />
              </vs-col>
               </vs-row>
              <vs-row >
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button  @click="downloadQR()">Download</vs-button>
              <!-- <vs-button class="ml-10">Print</vs-button> -->

              </vs-col>
               </vs-row>
    <!-- <div > -->
    <!-- <img :src="QRcodeImg" width="60%" hight="50%" download /><br> -->
    <!-- <div > -->
       <!-- <vs-button  @click="QRpopupActive=false">{{ $t('common.save') }}</vs-button> -->

    <!-- </div>
    </div> -->
  </vs-popup>
  <div class="demo-alignment">
      <vs-popup fullscreen title="" :active.sync="ArchivePopup">
        <data-list-archive :isarchiveActive="archiveSidebar" @getdata="getdata" @popActive="popActive"/> 
            <vs-popup title="Permanent Delete" :active.sync="popupActive3" >
        <div class="flex"> 
        <p>Are You about to Permanent Delete ?</p> <vs-button @click="permanentDelete()" class="ml-2" size="small" color="danger">Yes</vs-button><vs-button @click="popupActive3=false" class="ml-5" size="small" color="primary">No</vs-button>
        </div>     
      </vs-popup>
      </vs-popup>
  </div>
  <vs-popup class="holamundo" title=" " :active.sync="SMSpopupActive">
  <vs-row class="pb-0">
  <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="8"  >
     <ul>
       <li v-for="(PhoneNumber, index) in SmsNumber" :key="index">
         <span class="flex">
        <vs-input class="pl-10 p-1" placeholder="Enter Phone" v-model="PhoneNumber.phone" style="width:350px" />
        <span  class="material-icons  text-danger mt-3"  @click="removeNumber(index)">close</span>
         </span>
       </li>
     </ul> 
  </vs-col>
   <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
     <ul >
       <li  v-for="(student, index) in sms_student" :key="index">
      <vs-chip >
      <vs-avatar :src="img_cdn+student.image"/>
      {{student.fname}} {{student.lname}}
      </vs-chip>
       </li>
     </ul> 
  </vs-col>
 </vs-row>
    
      
              <vs-row class="mt-0 pt-0">
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6" class="w-full">
              <span  class="material-icons  text-primary ml-10"  @click="addNewNumber()">add</span>
              <!-- <vs-button  color="primary"  size="small">+</vs-button> -->
              <vs-button class="ml-20" color="success" >Send</vs-button>
              </vs-col>
               </vs-row>
           
    
             <!-- <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12" class="w-full">
               <label for="">Phone: </label>    <vs-input></vs-input>
              </vs-col>
               </vs-row>
              <vs-row >
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-button  color="success">Send</vs-button>
              </vs-col>
               </vs-row> -->
  </vs-popup>

  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import StudentSettingSidebar from './StudentSettingSidebar.vue'
import DataViewSidebar from './DataViewSidebar.vue'
import InviteCamUserSidebar from './InviteCamUserSidebar.vue'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import DataListArchive from './DataListArchive'
import {
  ALL_CAMERAS,
  ALL_LOCATIONS,
  ALL_STUDENTS,
  CAMERAS_BY_MANAGER_LOCATION,
  DELETE_IMAGE,
  GET_CAMERA_BY_LOCATION,
  ME_DATA,
  PLAY_CAMERA,
  REMOVE_STUDENT,
  SINGLE_USER,
  STUDENTS_BY_LOCATION,
  UPDATE_STUDENT_STATUS,
  UPDATE_USER_ACTIVITY,
  USER_EMAIL_CONFIRMED,
  GENERATE_QR,
  GENERATE_SMS_LINK,
  FORCE_DELETE_STUDENT,
  FORCE_DELETE_ALL_STUDENT
} from '@/graphql'

export default {
  components: {
    'DataViewSidebar': DataViewSidebar,
    'DataViewCamusersidebar': InviteCamUserSidebar,
    'StudentSettingSidebar': StudentSettingSidebar,
    'ScheduleViewSidebar': ScheduleViewSidebar,
    'DataListArchive': DataListArchive,
     VueQrcode,
  },
  data() {
    return {
      order:false,
      statusorder:true,
      state:false,
      namestate:false,
      QRpopupActive: false,
      IframeSrc:'',
      headCheckbox:'',
      selectedCheck:[],
      encrptId: '',
      students: [],
      selected: [],
      cameras: [],
      locations: [],
      itemsPerPage: 10,
      isMounted: false,
      meID: '',
      meRole: '',
      img_cdn: '',
      lng:'',
      types: [
      'sound',
    ],
    
      QRcodeImg:require('@/assets/images/portrait/small/qrcode.png'),
      popupActive: false,
      activeLoading:false,
      custom_search_filter:'Search By Location',
      custom_search_filter_camera:'Search By Camera',
      // products: [],

      // Data Sidebar
      addNewDataSidebar: false,
      archiveSidebar: false,
      addNewCamUserSidebar: false,
      addSettingSidebar: false,
      addPasswordSidebar:false,
      addScheduleSidebar:false,
      sidebarSettingData: {},
      sidebarData: {},
      camUserSidebarData : {},
      scheduleData:{},
      Imgdlt:'',
      DeletedItem:'',
      loc_id:'',
      qr_link:'google.com',
      action:'',
      ArchivePopup:false,
      popupActive3:false,
      SMSpopupActive:false,
      SmsNumber:[{
        phone :''
        }
      ],
      sms_link:'',
      sms_student:'',
    }
  },
  computed: {
      filteredStudentList: function () {
      var custom_search_filter_camera = this.custom_search_filter_camera
      var custom_search_filter = this.custom_search_filter
      return this.students.filter(function(student) {
        if (custom_search_filter_camera != 'Search By Camera' && custom_search_filter == 'Search By Location') {
          for (var i = 0; i < student.cameras.length; i++) {
            if (student.cameras[i].name == custom_search_filter_camera) {
              return true;
            }
          }
          return false
        }
        else if (custom_search_filter_camera != 'Search By Camera' && custom_search_filter != 'Search By Location') {
          for (var i = 0; i < student.cameras.length; i++) {
            if (student.cameras[i].name == custom_search_filter_camera && student.location.name == custom_search_filter) {
              return true;
            }
          }
          return false
        } else if (custom_search_filter_camera == 'Search By Camera' && custom_search_filter != 'Search By Location') {

          if (student.location.name == custom_search_filter) {
            return true;
          } else {
            return false;

          }
        }
        else if (custom_search_filter == 'Search By Location') {
         return true;
        }
        // if(custom_search_filter !== 'Search By Location'){
        //   return student.location.name.match(custom_search_filter);
        // }
        return true;
      });
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },

    locln() {
      return this.locations.length
    },
    queriedStudents () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.students.length
    },
    select (){
        return this.selected.length
    },
    reset(){
       if(this.popupActive){
         return this.IframeSrc
       }
       if(!this.popupActive){
         return
       }
    },
    Qr_link(){
      return this.qr_link
    }
  },
methods: {
  SMSpopup(){
     var path="/register"
       this.qr_link=process.env.VUE_APP_QR_LINK + path
       this.$apollo
           .mutate({
            mutation: GENERATE_SMS_LINK,
            variables: {
            link:this.qr_link,
            student_id:this.selected,
           }
          })
            .then(response => {
              if (response) {
                console.log(response)
                this.sms_link=response.data.generateSms.link
                 this.sms_student=response.data.generateSms.students
              this.SMSpopupActive=true
                   this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                          }
            }).catch(error => {
            console.log(error)
          });
  },
  addNewNumber() {
      this.SmsNumber.push({phone:""});
    },
   removeNumber(index) {
      this.SmsNumber.splice(index, 1);
    },  
  popActive(id){
    this.DeletedItem=id
    this.popupActive3=true
  },
    permanentDelete(){
         this.$apollo
              .mutate({
                mutation: FORCE_DELETE_ALL_STUDENT,
                variables: {
                  id: this.DeletedItem,
                }
              }).then(response => {
                this.popupActive3=false
                this.ArchivePopup=false
                this.DeletedItem=''
                if(response.data.forceDeleteAllStudent.status=='Success'){
                this.StatusSuccess(response.data.forceDeleteAllStudent.message,response.data.forceDeleteAllStudent.color)
                this.getArchive()
              }
              //  if(response.data.deleteAllStudent.status=='Success'){
              //  this.StatusSuccess(response.data.deleteAllStudent.message,response.data.deleteAllStudent.color)
              //  this.$emit('getdata',true)
          // }
            }).catch(error => {

            });
    //     this.$apollo
    //   .mutate({
    //     mutation: FORCE_DELETE_STUDENT,
    //     variables: {
    //     id: this.DeletedItem,
    //  },
    //   })
    //   .then(response => {
    //      this.popupActive3=false
    //      this.ArchivePopup=false
    //      if(response.data.forceDeleteStudent.status=='Success'){
    //         this.StatusSuccess(response.data.forceDeleteStudent.message,response.data.forceDeleteStudent.color)
    //         this.getArchive()
    //       }
    //     }).catch(error => {
    //      console.log(error)
    //   });
  },
  getArchive(){
    this.ArchivePopup=true
    this.archiveSidebar=!this.archiveSidebar

  },
  downloadQR(){
    var img=this.$refs.QR.$el
     var a = document.createElement('a');
        a.href = img.src;
        a.download = 'QR_CODE';
       a.click();
      this.QRpopupActive=false
  },
    genQr(){
       var path="/register"
       this.qr_link=process.env.VUE_APP_QR_LINK + path
       this.$apollo
           .mutate({
            mutation: GENERATE_QR,
            variables: {
            link:this.qr_link,
            student_id:this.selected,
           }
          })
            .then(response => {
              if (response) {
              this.qr_link=response.data.generateQr.color
              this.QRpopupActive=true
                   this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                          }
            }).catch(error => {
            console.log(error)
          });




    },
    sorting(name){
    this.namestate=true
    this.state=false
    var column=name
    this.statusorder=true
    var order=this.order
    if(column=='name' && order==true){
    this.order=!this.order
    this.students.sort(function(a, b) {
    var textA = a.fname.toUpperCase();
    var textB = b.fname.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='name' && order==false){
    this.order=!this.order
    this.students.sort(function(a, b) {
    var textA = a.fname.toUpperCase();
    var textB = b.fname.toUpperCase();
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
sortingstatus(name){
   this.state=true
   this.namestate=false
   var column=name
   this.order=true
   var statusorder=this.statusorder
  if(column=='status' && statusorder==true){
    this.statusorder=!this.statusorder
    this.students.sort(function(a, b) {
    var textA = a.status
    var textB = b.status
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='status' && statusorder==false){
   this.statusorder=!this.statusorder
    this.students.sort(function(a, b) {
    var textA = a.status
    var textB = b.status
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
  getdata(value){
     if(value){
       this.get()
     }
     },
  updateCamraList(id){
    this.custom_search_filter_camera = 'Search By Camera'

    if(id=='all'){
      this.$apollo
        .mutate({
          mutation: ALL_CAMERAS,
        })
        .then(response => {
          this.cameras = response.data.cameras
        })
    }
    else if(id){
      this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id:id
          }
        })
        .then(response => {
          if (response){
            this.cameras=response.data.location_cameras

          }
        }) .catch(error => {
        console.log(error)
      });
    }


    },
  PalyCamera(){
           this.$apollo
           .mutate({
            mutation: PLAY_CAMERA,
            variables: {
            id:'0',
           }
          })
            .then(response => {
              if (response) {
              this.IframeSrc=response.data.playCamera.embed_code
              this.popupActive=true
                          }
            }).catch(error => {
            console.log(error)
          });
    },
  CheckAll(){
    var selected=[]
    if(this.headCheckbox){
    for (let index = 0; index < this.students.length; index++) {
                 this.selectedCheck[index]=true;
                 selected.push(this.students[index].id)
                 }
        this.selected=selected
    }
    else{
      for (let index = 0; index < this.students.length; index++) {
                 this.selectedCheck[index]=false;
                 }
        this.selected=[]
    }
  },
  ConfirmNotification(status) {
      this.$vs.notify({
        title: this.$t('menu.students.name'),
        text: status+' Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
selectAction(action){
  this.action=action
  if(action=='deletestudent'){
        this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete selected student`,
        accept: this.delefun,
        acceptText: 'Delete'
      });
  }
  else{
 if(this.selected.length>0){
     this.$apollo
              .mutate({
                mutation: USER_EMAIL_CONFIRMED,
                variables: {
                  name: action,
                  user_ids: this.selected,
                }
              }).then(response => {
              if(response){
                this.ConfirmNotification(response.data.confirmUserEmail.status)
                this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                this.get();
              }
            }).catch(error => {

            });

}
  }
},
 delefun(){
         if(this.selected.length>0){
            this.$apollo
              .mutate({
                mutation: USER_EMAIL_CONFIRMED,
                variables: {
                  name: this.action,
                  user_ids: this.selected,
                }
              }).then(response => {
              if(response){
                this.ConfirmNotification(response.data.confirmUserEmail.status)
                this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                this.get();
              }
            }).catch(error => {

            });
}
    },
SelectItem(id){
    if(!this.headCheckbox){
    var status=false
    for (var i = 0; i < this.selected.length; i++) {
    if (this.selected[i] == id) {
       status=true
    }
  }
  if(status){
  this.selected.pop(id)
  }
  else{
      this.selected.push(id)
  }
}
else{
    const index = this.selected.indexOf(id);
   if (index > -1) {
     this.selected.splice(index, 1);
  }
  else{
     this.selected.push(id)
  }
}
},
    confStatus(status,id){
       this.$apollo
          .mutate({
          mutation: UPDATE_STUDENT_STATUS,
          variables: {
          id :id,
          status:status
          }
        }).then(response => {
         if (response) {
           this.acceptAlert()
           this.updateUserActivity(response.data.updateStudentStatus.id)

         }
       }).catch(error => {
         console.log(error)
       });

    },

    setSelected(value) {
      this.custom_search_filter = value;
    },
    cameraSelected(value) {
      this.custom_search_filter_camera = value;
    },
  updateUserActivity (id) {

    this.$apollo
      .mutate({
        mutation: UPDATE_USER_ACTIVITY,
        variables: {
          object_id: id,
          object_type:"App\\Models\\User",
          activity:"updated"
        }
      })
  },
    acceptAlert(status) {
        this.$vs.notify({
        color: 'success',
        title: this.$t('student.alert_title'),
        position:'top-right',
        text: 'Status Updated Successfully!'

      })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
     settingData (data) {
      this.sidebarSettingData = data

      this.toggleSettingSidebar(true)
    },
      StatusSuccess(status,color) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   status,
        color:  color,
        position: 'top-right'
      })

    },
   confirmDeleteRecord (student) {
      this.DeletedItem=student
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${student.fname} ${student.lname}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
    this.Imgdlt=this.DeletedItem.image
     this.$apollo
      .mutate({
        mutation: REMOVE_STUDENT,
        variables: {
        id: this.DeletedItem.id,
     },
      })
      .then(response => {
          this.get()
          if(response.data.deleteStudent.status=='Success'){
            this.StatusSuccess(response.data.deleteStudent.message,response.data.deleteStudent.color)
          }
          else{
            this.StatusSuccess(response.data.deleteStudent.message,response.data.deleteStudent.color)
          }
        }).catch(error => {
         console.log(error)
      });
    //   this.$apollo
    //   .mutate({
    //     mutation: DELETE_IMAGE,
    //     variables: {
    //     image: this.Imgdlt,
    //  },
    //   })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    viewData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleCamUserSidebar (val = false) {
      this.addNewCamUserSidebar = val
    },
    toggleSettingSidebar (val = false) {
      this.addSettingSidebar = val
    },
    togglePassswordSidebar (val = false) {
      this.addPasswordSidebar = val
    },
  conditionMethod(role,id){
     if(role=="manager"){
      this.$apollo
      .mutate({
        mutation: STUDENTS_BY_LOCATION,
        variables: {
        id:id
     },
      })
        .then(response => {
          this.students=[]
          this.locations=response.data.studentsbyLocation.managerlocations
          for (let i = 0; i < response.data.studentsbyLocation.managerlocations.length; i++) {
            for (let j = 0; j < response.data.studentsbyLocation.managerlocations[i].students.length; j++) {
                  this.students.push(response.data.studentsbyLocation.managerlocations[i].students[j])
            }
          }
        this.activeLoading = false
        this.$vs.loading.close()
        this.order=!this.order
        this.sorting('name')
      }).catch(error => {
          console.log(error)
      });
      this.$apollo
      .mutate({
        mutation: CAMERAS_BY_MANAGER_LOCATION,
        variables: {
        id:id
     },
      })
      .then(response => {
        var cameras=[]
        var users=[]
         for (let i = 0; i < response.data.user.managerlocations.length; i++) {
            for (let j = 0; j < response.data.user.managerlocations[i].cameras.length; j++) {
                  cameras.push(response.data.user.managerlocations[i].cameras[j])
            }
          }
        this.cameras=cameras
      }).catch(error => {
          console.log(error)
      });

      }
      if(role=="user"){
      this.$apollo
      .mutate({
        mutation: SINGLE_USER,
      variables: {
        id:id
     },
      })
      .then(response => {
        this.students=response.data.user.students
        this.order=!this.order
        this.sorting('name')
        this.activeLoading = false
        this.$vs.loading.close()
      })
      }
    if(role=="admin" || role=="center"){
      this.$apollo
      .mutate({
        mutation: ALL_STUDENTS,
      })
      .then(response => {
          this.students=response.data.students
          this.order=!this.order
          this.sorting('name')
          this.activeLoading = false
          this.$vs.loading.close()
      })
     this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.locations

      })
    this.$apollo
      .mutate({
        mutation: ALL_CAMERAS,
      })
      .then(response => {
        this.cameras = response.data.cameras
      })
    }
  },
     get(){
     this.$apollo
      .mutate({
        mutation: ME_DATA,
      })
      .then(response => {
        this.conditionMethod(response.data.me.roles[0].name,response.data.me.id)
      }).catch(error => {
          console.log(error)
      });

  }
  },
  created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.lng=process.env.VUE_APP_I18N_LOCALE
    this.get()

    const result = Math.random().toString(36).substring(2, 15);
    this.encrptId = "getrhmw7zcbabcdefghijklmnTrst1234wxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz"


  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate() {
    this.activeLoading = true
      this.$vs.loading({
        type:'sound',
      })

  }
}
</script>

<style lang="scss">
#data-list-list-view {
.user_add_btn{
    float: right ;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {

      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
      .product-img {
                height: 50px;
                border-radius: 50%;
              }
  }
  [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .studentdot{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:-10px;
  margin-bottom:5px;
  }
}
 .popupWidth{
    width: 400px !important;
  }
</style>
